import { Injectable,  OnInit, trigger, EventEmitter, state, style, Output, keyframes,  transition, animate } from '@angular/core';
import { Router } from '@angular/router';
 

import {   HostBinding } from '@angular/core';

import { AngularFireAuthModule } from 'angularfire2/auth';
import { Http, RequestOptions, Headers }       from '@angular/http';

import { AngularFireAuth } from 'angularfire2/auth';
 
//import { moveIn } from '../router.animations';

import { AngularFireDatabase, FirebaseListObservable } from 'angularfire2/database';
import 'rxjs/add/operator/toPromise';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/observable/interval';
import * as firebase from 'firebase/app';  
 
import 'rxjs/Rx';
import { TimerObservable } from "rxjs/observable/TimerObservable";
import { URLSearchParams } from '@angular/http'; 
import { IntervalObservable } from "rxjs/observable/IntervalObservable";
import { environment } from 'environments/environment';



 
 
 

@Injectable()
export class CustomerLoginService implements OnInit {

    user: Observable<firebase.User>;
    items: FirebaseListObservable<any[]>;


     public  customer: any;

    msgVal: string = '';
    flip: string = 'inactive';

   
    isLoggedIn:boolean=false;

    hasError:boolean = false;
 
 
    errorMessage:string=""; 

 
 

    public email:string;

    interval: 100;


    display:boolean;
    alive:boolean;
 

Customer:string=environment.apiRoot+'Customer';



timer:any;


@Output () public profileUpdateEvent = new EventEmitter <any>();




    constructor(public router: Router, public http:Http,  public afAuth: AngularFireAuth, public af: AngularFireDatabase) {

        this.items = af.list('/messages', {
            query: {
              limitToLast: 50
            }
          });

          this.timer = Observable.timer( 1000, 30000);

          this.timer.subscribe ( t=> { 
              
       

         if ( this.isLoggedIn)
             this.onLoggedin(this.customer.email , sessionStorage.getItem('authToken'));
           
           
        
        });
}

    ngOnInit() {

       

   
       
    }

    
 public    AgentProfileUpdated () {

      this.profileUpdateEvent.emit(this.customer);

    }


   

 



    login ( email:string, password: string): Promise <any> {
        console.info("agentDDS ");
        let promise =  new Promise (  ( resolve, reject ) =>
        { 
        
            console.info("agentDDS ");
        // verify user via firebase sdk 
        
        this.loginFireBase( email, password).then ( response => 
         
         {
    
           //console.info("agentDDS2"+response);
 
             this.GetUserToken ().then (  authToken => {
                console.info(authToken);

                    this.onLoggedin(email , authToken).then (  response => {
                 
                        
                    resolve();
            

                    }).catch(error =>  {    reject(error  )});
 
             } ).catch(error => {   reject(error )} );
 

         
         } 
     
         ).catch(error => {            console.info("  agentDDS");
         ; reject(error )} );
        
        
         });
 
 
      return  promise;

    }
   
   
    onLoggedin(email:string , authToken: any) : Promise <any> {


        console.log("Agents profile was updated");


          let promise = new Promise (  ( resolve, reject ) =>
     
          { 
          

            let params = '';
                        
            let options = new RequestOptions({
                    // Have to make a URLSearchParams with a query string

                   
                    search: new URLSearchParams('email='+email) // <-----
                   
                });
               

                let header = new Headers();

                header.append( "authToken", authToken );
    
                options.headers = header;

               


                
               this.http.get(environment.apiRoot+"Customer",options  )
                .toPromise()
                .then(response =>  { 
                    
                    
                     
                    this.customer = response.json() ;  

                    console.info( response.json()     );
                   
                    sessionStorage.setItem('isLoggedin', 'true');
                    
                    this.email=this.customer.email;
                    
                    this.isLoggedIn=true; 
                    
                   
                    this.profileUpdateEvent.emit(this.customer);
            
                   resolve(this.customer);

                
                
                }).catch(error => { reject(error  );}  ) ;

            });


                return promise;

                    
    }
 
    loginFireBase( email:string, password:string): Promise <any>  {

        
        let promise =  this.afAuth.auth.signInWithEmailAndPassword( email,  password
        );
      
        return <Promise<any> > promise;

  
    }

    GetUserToken( ): Promise<any>  {


        
       

        let headerToken = new Promise (  ( resolve, reject ) =>
        { 
     
              this.afAuth.auth.currentUser.getIdToken(true).then( token =>

                {
                 
                    sessionStorage.setItem( 'authToken', token);


              
                resolve(token);


                 }).catch ( a => reject() );

                } 

           );


           

        
       


     

        return headerToken;

 
 
          
    }

   

    
    logout() {
        this.afAuth.auth.signOut();
    }
    
    Send(desc: string) {
        this.items.push({ message: desc});
        this.msgVal = '';
    }


    
    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error); // for demo purposes only
        return Promise.reject(error.message || error);
      }


    
  

            
 

    
 


       
 
  

 
    
}



// WEBPACK FOOTER //
// C:/Users/bishop.duperret.GOMURAL/Documents/ConciergeDashboard/gomural-mural-outlook-configuration-dashboard-43c2b5785cd3/src/app/customer/customerlogin/customerlogin.service.ts